import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PalantirSize } from '@core/interfaces/palantir/sizes.interface';
import { PalantirSizeEnum } from '@core/interfaces/palantir/sizes.interface';
import { PalantirTextType } from './text.type';
import { PalantirTextTypeEnum } from './text.type';

@Component({
  selector: 'palantir-text',
  templateUrl: './palantir-text.component.html',
  styleUrls: ['./palantir-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PalantirTextComponent {
  @Input() public type: PalantirTextType = PalantirTextTypeEnum.text;
  @Input() public size: PalantirSize = PalantirSizeEnum.base;
  @Input() public truncate?: boolean | 'false' | 'true' = false;
  @Input() public italic?: boolean | 'false' | 'true' = false;
}
